function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  fill: "#fff",
  stroke: "#00e5ae",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 10.5,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_148",
  "data-name": "Group 148",
  transform: "translate(10.062 5.75)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_117",
  "data-name": "Rectangle 117",
  width: 2.156,
  height: 7.188,
  transform: "translate(0 4.313)",
  fill: "#3458a4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_118",
  "data-name": "Rectangle 118",
  width: 2.156,
  height: 2.156,
  fill: "#3458a4"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_30",
  "data-name": "Ellipse 30",
  fill: "#fff",
  stroke: "#00e5ae",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 10.5,
  fill: "none"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1249",
  "data-name": "Group 1249",
  transform: "translate(10.063 5.75)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_117-2",
  "data-name": "Rectangle 117",
  width: 2.156,
  height: 7.188,
  transform: "translate(0 4.313)",
  fill: "#3458a4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_118-2",
  "data-name": "Rectangle 118",
  width: 2.156,
  height: 2.156,
  fill: "#3458a4"
}));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.3c17f15c.svg";
export { ForwardRef as ReactComponent };